<template>
    <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                    v-model="computedDateFormatted"
                    :label="label"
                    persistent-hint
                    readonly
                    v-on="on"
                    :rules="rules"
            ></v-text-field>
        </template>
        <v-date-picker :value="value" v-on="$listeners" no-title @input="menu = false"></v-date-picker>
    </v-menu>
</template>

<script>
    export default {
        name: "DatePicker",
        props: {
            value: String,
            label: String,
            rules: Array
        },
        data() {
            return {
                menu: false,
            }
        },

        computed: {
            computedDateFormatted() {
                if (!this.value) {
                    return '';
                } else {
                    return this.$moment(this.value).format('DD.MM.YYYY')
                }
            },
        },
    }
</script>

<style scoped>
</style>
